export default "__VITE_ASSET__V7s9ozCq__"